module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA5UlEQVQ4je3UvUpDMRiH8d85PYOC4Cjo5mRdHcVNsE5eR/ELNyd1rVOha6+ieAl19AYc3N0UnKSggx4JMcePE0efKXnf/B8SQlI8nC1pYB19bGMVL7jDFca4TYWKhLDCAEfv4xQzjHCK5zgczyfYbdp2sO4EXeyF0jJaOPiBLKSHy7AQCrs4/oWsZh9rKeEBOi2EFQ5Twl4LWc1OSricIVxJCecyhB/Z+Jaz+Rfm0/T429BBWeLG29eUywzXf33k+QobcXXx6f7b5ONC+mOuhmX/U/HcRT2cYjNqT7GVytHulouvmq8bPB9mvEnxNgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/msg.png
// module id = 3bTG
// module chunks = 20